import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DocsService } from './docs.service';
import { GithubManagerService } from './github-manager.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  level: string[] = [
    'very easy',
    'easy',
    'medium',
    'hard',
    'ninja'
  ];

  cost: string[] = [
    '< 50 €',
    '50€ - 250€',
    '250€ - 500€',
    '500k€ - 1k€',
    '> 1k€'
  ]
  constructor(
    public docs: DocsService,
    private github: GithubManagerService
  ) {}

  ngOnInit() {
  }

  save() {
    this.docs.save();
  }

  download() {
    this.docs.downlaod();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts